<template>
  <div>
    <v-list-item @click.stop="onDialog" link v-if="!hideTitleForm">
      <v-list-item-title>自社見合</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-form ref="form">
          <v-card-title><span class="headline">自社見合</span></v-card-title>
          <v-divider></v-divider>
          <v-card-text class="container grid-list-md body-content-dialog">
            <v-layout wrap>
              <v-flex xs6>
                <v-select v-model="dataInternalMatchmaking.option.shift" :items="shifts" :rules="rules.shift"
                  item-text="label" item-value="value" label="ｼﾌﾄ" @change="openDialogCV"
                  :readonly="dataInternalMatchmaking.option.shift == 1"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select :items="kinds" v-model="dataInternalMatchmaking.kind" :rules="rules.kind" @change="changeKind"
                  item-text="label" item-value="value" label="取組区分"></v-select>
              </v-flex>
              <v-flex xs6 class="d-flex align-center">
                <v-checkbox v-model="dataInternalMatchmaking.is_online" label="オンライン"></v-checkbox>
              </v-flex>
              <template v-if="dataInternalMatchmaking.status == statusPlan">
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.status" :items="status" :rules="rules.status"
                    item-text="text" item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs6 class="d-flex align-center">
                  <v-checkbox v-model="dataInternalMatchmaking.option.verTel" label="日時確認済"></v-checkbox>
                </v-flex>
              </template>
              <template v-else-if="dataInternalMatchmaking.status == statusImplementation">
                <v-flex xs3>
                  <v-select v-model="dataInternalMatchmaking.status" :items="status" :rules="rules.status"
                    item-text="text" item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select :items="result" item-text="label" item-value="value" label="結果"
                    v-model="dataInternalMatchmaking.option.result"></v-select>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataInternalMatchmaking.option.follTel" label="フォローTEL済"></v-checkbox>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataInternalMatchmaking.option.resTel" label="結果報告TEL済"></v-checkbox>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.status" :items="status" :rules="rules.status"
                    item-text="text" item-value="value" label="状態"></v-select>
                </v-flex>
              </template>
              <v-flex xs3 class="d-flex align-center">
                <v-checkbox v-model="dataInternalMatchmaking.option.isPay" label="入金確認済"></v-checkbox>
              </v-flex>
              <v-flex xs3 v-if="dataInternalMatchmaking.option.isPay">
                <v-text-field value="0" label="入金額" v-model="dataInternalMatchmaking.option.payVal">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" :rules="rules.target_date" readonly label="日付"
                      append-icon="mdi-calendar" persistent-hint v-bind="attrs" v-on="on" width="120px">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataInternalMatchmaking.target_date"
                    :day-format="(target_date) => new Date(target_date).getDate()" no-title></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- target_time -->
              <v-flex xs6>
                <v-dialog ref="dialog1" v-model="timePick['target_time']"
                  :return-value.sync="dataInternalMatchmaking.target_time" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataInternalMatchmaking.target_time" :rules="rules.target_time" label="実施時刻"
                      readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time']" v-model="dataInternalMatchmaking.target_time" full-width
                    scrollable format="24hr" @change="changeTimeStart($event)">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveTimeStart">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- end at -->
              <v-flex xs6>
                <v-dialog ref="dialog2" v-model="timePick['target_time_end']"
                  :return-value.sync="dataInternalMatchmaking.target_time_end" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataInternalMatchmaking.target_time_end" :rules="rules.target_time_end"
                      label="終了時刻" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time_end']" v-model="dataInternalMatchmaking.target_time_end"
                    :min="minTime" full-width scrollable format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time_end'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog2.save(dataInternalMatchmaking.target_time_end)">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- phone -->
              <v-flex xs6>
                <v-text-field v-model="phoneMale" name="male" :rules="rules.phoneMale" @blur="apiPhone($event)"
                  ref="phoneMale" type="text" label="携帯番号(男性会員)" :readonly="customerMaleFromHistory" id="phoneMale">
                </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-autocomplete v-model="nameMale" :rules="rules.nameMale" label="会員名(男性会員)"
                  @keydown="focusCustomerName" @update:search-input="debounceMale" @input="inputCustomerNameMale"
                  :items="itemFamilyNameMales" @blur="blurNameMale"
                  :readonly="customerMaleFromHistory"></v-autocomplete>
              </v-flex>

              <!-- counselor -->
              <template v-if="!isTheSameShop">
                <!-- male counselor -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.counselor_id" :items="counselors1" :rules="rules.counselor"
                    item-text="name" item-value="id" label="男性担当者" @change="onCounselor1Selected">
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-flex>
                <!-- male booth no -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.booth_no_id" :items="validBoothNos" :rules="rules.boothNo"
                    item-text="booth_no" item-value="id" label="男性ブースNo"></v-select>
                </v-flex>
              </template>

              <!-- phone -->
              <v-flex xs6>
                <v-text-field v-model="phoneFemale" name="female" :rules="rules.phoneFemale" @blur="apiPhone($event)"
                  ref="phoneFemale" type="text" label="携帯番号(女性会員)" :readonly="customerFeMaleFromHistory">
                </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-autocomplete v-model="nameFemale" :rules="rules.nameFemale" label="会員名(女性会員)"
                  @keydown="focusCustomerName" @update:search-input="debounceFemale" @input="inputCustomerNameFemale"
                  :items="itemFamilyNameFemales" @blur="blurNameFemale"
                  :readonly="customerFeMaleFromHistory"></v-autocomplete>
              </v-flex>

              <template v-if="!isTheSameShop">
                <!-- female counselor -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.counselor2_id" :items="counselors2"
                    :rules="rules.counselor" item-text="name" item-value="id" label="女性担当者"
                    @change="onCounselor2Selected">
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-flex>
                <!-- female booth no -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.booth_no2_id" :items="validBoothNos2"
                    :rules="rules.boothNo2" item-text="booth_no" item-value="id" label="女性担ブースNo"></v-select>
                </v-flex>
              </template>

              <template v-if="isTheSameShop">
                <!-- counselor -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.counselor_id" :items="counselors1" :rules="rules.counselor"
                    item-text="name" item-value="id" label="入力者" @change="onCounselorSelected">
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-flex>
                <!-- booth no -->
                <v-flex xs6>
                  <v-select v-model="dataInternalMatchmaking.booth_no_id" :items="validBoothNos" :rules="rules.boothNo"
                    item-text="booth_no" item-value="id" label="ブース№"></v-select>
                </v-flex>
              </template>

              <!-- note -->
              <v-flex xs12>
                <v-textarea 
                  label="メモ" 
                  v-model="dataInternalMatchmaking.note" 
                  :rules="rules.note"
                  :rows="3"
                  @input="onMemoInput"
                  @click="onMemoClick"
                  ref="memoTextarea"
                  class="memo-textarea"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="132" class="info" @click="checkHistory">登録</v-btn>
            <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
            <v-btn width="132" class="error" v-if="typeSubmit == 'update'" @click="resetForm">削除</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <CompanyVisit :shop_id="shop_id" :date="date" :dialogCV="dialogCV" @closeDialogCV="closeDialogCV"
      :boothNos="boothNos" :counselors="counselors" :hideTitle="true" :valueKindForShift="kindShift" />

    <v-dialog width="500" v-model="showConfirmCustomerSame" persistent>
      <template>
        <v-card title="Dialog">
          <v-card-text class="pt-5">
            過去にお見合いを実施したことがある方ですが、よろしいですか？
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn @click="closePopupChangeMatchedCustomer" class="info">そのまま</v-btn>
            <v-btn @click="changeMatchedCustomer">変更する</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <MemoEditorDialog
      :visible.sync="memoDialog"
      v-model="dataInternalMatchmaking.note"
      :rules="rules.note"
    />
  </div>
</template>
<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import { required, inArray, date, phone, digits, max, isSelectedCounselor } from '@/utilities/validation.js';
import CompanyVisit from "./CompanyVisit.vue";
import constants from '@/consts/constants.js'
import store from '@/store'
import Swal from 'sweetalert2';
import MemoEditorDialog from '@/components/common/MemoEditorDialog.vue'

export default {
  name: "InHouseMatchmaking",
  components: { CompanyVisit, MemoEditorDialog },
  props: ['date', 'boothNos', 'shop_id', 'counselors', 'historyData', 'showFormInHouseMatching', 'hideTitleForm', 'valueKindForForm', 'customer', 'isLedgerScreen', 'boothNos2', 'isOnlineShop'],

  data: function () {
    const shifts = CUSTOMER.SHIFTS
    const statusPayments = CUSTOMER.STATUS_PAYMENTS
    const resultTELs = CUSTOMER.RESULT_TELS
    const result = CUSTOMER.RESULT
    const statusPlan = CUSTOMER.STATUS_DEFAULT.getValue('予定')
    const statusImplementation = CUSTOMER.STATUS_DEFAULT.getValue('実施')
    const kinds = [
      { label: CUSTOMER.EXEC_KIND.NAME.MATCHING, value: CUSTOMER.EXEC_KIND.VAL.MATCHING },
      { label: CUSTOMER.EXEC_KIND.NAME.OTHER_BRANCH_MATCHMAKING, value: CUSTOMER.EXEC_KIND.VAL.OTHER_BRANCH_MATCHMAKING },
      { label: CUSTOMER.EXEC_KIND.NAME.SOLO_INTRODUCTION, value: CUSTOMER.EXEC_KIND.VAL.SOLO_INTRODUCTION },
    ]

    return {
      // validate
      rules: {
        shift: [
          (v) => required(v),
          (v) => inArray(v, shifts.map(item => item.value)),
        ],
        status: [
          (v) => required(v),
          (v) => inArray(v, this.status.map(item => item.value)),
        ],
        statusPayment: [
          (v) => required(v),
          (v) => inArray(v, statusPayments.map(item => item.value)),
        ],
        resultTEL: [
          (v) => required(v),
          (v) => inArray(v, resultTELs.map(item => item.value)),
        ],
        target_date: [
          (v) => required(v),
          (v) => date(v),
        ],
        counselor: [
          (v) => required(v),
        ],
        target_time: [
          (v) => required(v),
        ],
        target_time_end: [
          (v) => required(v),
        ],
        phoneMale: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        nameMale: [
          (v) => required(v),
        ],
        phoneFemale: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        nameFemale: [
          (v) => required(v),
        ],
        boothNo: [
          () => isSelectedCounselor(this.dataInternalMatchmaking.counselor_id),
          (v) => required(v),
          (v) => inArray(v, this.validBoothNos.map(item => item.id))
        ],
        boothNo2: [
          () => isSelectedCounselor(this.dataInternalMatchmaking.counselor2_id),
          (v) => required(v),
          (v) => inArray(v, this.validBoothNos2.map(item => item.id)),
        ],
        shop: [
          (v) => required(v),
        ],
        note: [
          (v) => max(v, 1000),
        ],
        result: [
          (v) => required(v),
        ],
        kind: [
          (v) => required(v),
          (v) => inArray(v, kinds.map(item => item.value)),
        ],
      },

      dataInternalMatchmaking: {
        kind: CUSTOMER.EXEC_KIND.NAME.MATCHING,
        status: statusPlan,
        target_date: this.date,
        counselor_id: "",
        counselor2_id: "",
        target_time: "",
        target_time_end: "",
        male_customer_id: "",
        female_customer_id: "",
        booth_no_id: "",
        booth_no2_id: "",
        note: "",
        type: constants.TYPE_FORM.IN_HOUSE_MATCH,
        is_online: false,
        option: {
          result: null,
          isPay: false,
          verTel: false,
          follTel: false,
          resTel: false,
          payVal: 0,
          shift: 0,
        },
      },
      shifts,
      status: CUSTOMER.STATUS_DEFAULT.LIST,
      statusPayments,
      resultTELs,
      timePick: [],
      isFamilyName: false,
      phoneMale: "",
      phoneMaleOld: "",
      nameMale: "",
      nameMaleOld: "",
      customerMales: '',
      itemFamilyNameMales: [],
      phoneFemale: "",
      phoneFemaleOld: "",
      nameFemale: "",
      nameFemaleOld: "",
      customerFemales: '',
      itemFamilyNameFemales: [],
      dialogForm: false,
      dialogCV: false,
      typeSubmit: null,
      typeFormInHouseMatchmaking: 2,
      addTimeWithKind: 0,
      minTime: null,
      kindShift: 102, //Kind SHIFT_CONTRACT
      timer: null,
      isValueForm: [24],
      customerMaleFromHistory: false,
      customerFeMaleFromHistory: false,
      statusPlan,
      statusImplementation,
      result,
      kinds,
      validBoothNos: [],
      validBoothNos2: [],
      isTheSameShop: true,
      isTheSameShopFemale: true,
      maleCustomer: null,
      femaleCustomer: null,
      counselors1: [],
      counselors2: [],
      showConfirmCustomerSame: false,
      genderOflastEnteredCustomer: CUSTOMER.GENDER.VAL.FEMALE,
      moment: moment,
      // memo modal state
      memoDialog: false,
    }
  },

  mounted() {
    this.getListCounselorInitial()
    this.getTimeAddFromKind()
  },
  computed: {

    computedDateFormatted() {
      return this.dataInternalMatchmaking.target_date ? this.formatDate(this.dataInternalMatchmaking.target_date) : this.formatDate(this.date)
    },
  },

  watch: {
    phoneMale: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }

        this.phoneMale = formatPhone;
      }
    },
    phoneFemale: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }

        this.phoneFemale = formatPhone;
      }
    },
    showFormInHouseMatching: function (newDialog) {
      this.dialogForm = newDialog
      if (newDialog) {
        // Auto blur phoneMale input
        setTimeout(() => {
          if (this.typeSubmit !== 'update') {
            const phoneMaleInput = document.getElementById('phoneMale')
            phoneMaleInput.focus()
            // Create a temporary hidden input and focus on it
            const tempInput = document.createElement('input')
            tempInput.style.position = 'absolute'
            tempInput.style.left = '-9999px'
            document.body.appendChild(tempInput)
            tempInput.focus()
            document.body.removeChild(tempInput)

            if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
              this.femaleCustomer = null
            } else {
              this.maleCustomer = null
            }
          }
        }, 100)
        if (this.customer) {
          if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
            this.maleCustomer = this.customer
            this.femaleCustomer = null
          } else {
            this.femaleCustomer = this.customer
            this.maleCustomer = null
          }
          const currentShopId = store.state.user.shop_id
          if (currentShopId !== 0 && this.customer.shop_id !== currentShopId) {
            setTimeout(() => {
              this.checkKindByCustomerShop()
              this.resetWhenChangeLayout()
            }, 200)
          } else if (currentShopId === 0) {
            setTimeout(() => {
              this.checkKindByCustomerShopForAdmin()
              this.resetWhenChangeLayoutForAdmin()
            }, 200)
          }
          if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
            this.phoneFemale = ""
            this.nameFemale = ""
            this.dataInternalMatchmaking.counselor_id = ""
            this.dataInternalMatchmaking.booth_no_id = ""
            this.validBoothNos = []
            this.counselors1 = []
          } else {
            this.phoneMale = ""
            this.nameMale = ""
            this.dataInternalMatchmaking.counselor2_id = ""
            this.dataInternalMatchmaking.booth_no2_id = ""
            this.validBoothNos2 = []
            this.counselor
          }
        }
      }
      
    },
    historyData: function (newDataHistory) {
      if (newDataHistory.type == constants.TYPE_FORM.IN_HOUSE_MATCH && this.valueKindForForm.length == 0) {
        this.dataInternalMatchmaking.kind = this.historyData.kind
        this.dataInternalMatchmaking.target_date = this.formatDateSlash(newDataHistory.target_date)
        this.dataInternalMatchmaking.target_time = newDataHistory.target_time
        this.dataInternalMatchmaking.target_time_end = newDataHistory.target_time_end
        this.dataInternalMatchmaking.customer_id = newDataHistory.customer_id
        this.dataInternalMatchmaking.booth_no_id = newDataHistory.booth_no_id
        this.dataInternalMatchmaking.counselor_id = newDataHistory.counselor_id
        this.dataInternalMatchmaking.note = newDataHistory.note
        // this.dataInternalMatchmaking.option = newDataHistory.option
        this.phoneMale = newDataHistory.male_customer.phone_number
        this.nameMale = newDataHistory.male_customer.family_name + newDataHistory.male_customer.given_name
        this.nameMaleOld = this.nameMale
        this.itemFamilyNameMales = [this.nameMale]
        this.dataInternalMatchmaking.option.counterpart_history_id = newDataHistory.option.counterpart_history_id
        this.dataInternalMatchmaking.option.female_customer_id = newDataHistory.option.female_customer_id
        this.dataInternalMatchmaking.option.isPay = newDataHistory.option.isPay
        this.dataInternalMatchmaking.option.male_customer_id = newDataHistory.option.male_customer_id
        this.dataInternalMatchmaking.option.match_reserve_id = newDataHistory.option.match_reserve_id
        this.dataInternalMatchmaking.option.shift = newDataHistory.option.shift
        this.dataInternalMatchmaking.option.result = newDataHistory.option.result
        this.dataInternalMatchmaking.option.isPay = newDataHistory.option.isPay
        this.dataInternalMatchmaking.option.verTel = newDataHistory.option.verTel
        this.dataInternalMatchmaking.option.follTel = newDataHistory.option.follTel
        this.dataInternalMatchmaking.option.resTel = newDataHistory.option.resTel
        this.dataInternalMatchmaking.option.payVal = newDataHistory.option.payVal
        this.dataInternalMatchmaking.status = newDataHistory.status
        this.phoneFemale = newDataHistory.female_customer.phone_number
        this.nameFemale = newDataHistory.female_customer.family_name + newDataHistory.female_customer.given_name
        this.nameFemaleOld = this.nameFemale
        this.itemFamilyNameFemales = [this.nameFemale]
        this.dataInternalMatchmaking.male_customer_id = newDataHistory.male_customer.id
        this.dataInternalMatchmaking.female_customer_id = newDataHistory.female_customer.id
        this.typeSubmit = 'update'
        this.validBoothNos = this.boothNos;
        this.validBoothNos2 = this.boothNos2;
        this.dataInternalMatchmaking.counselor2_id = newDataHistory.counselor2_id
        this.dataInternalMatchmaking.booth_no2_id = newDataHistory.booth_no2_id
        this.dataInternalMatchmaking.is_online = newDataHistory.is_online == 1
        this.maleCustomer = newDataHistory.male_customer
        this.femaleCustomer = newDataHistory.female_customer
        this.counselors1 = this.counselors
        if (newDataHistory.counselor2_id && newDataHistory.booth_no2_id && newDataHistory.counselor2_id !== "" && newDataHistory.booth_no2_id !== "") {
          if (store.state.user.shop_id !== 0) {
            this.getCounselors()
          } else {
            this.getCounselorsForAdmin()
          }
        }
      }
    },
    valueKindForForm: function (newValueKindForForm) {
      if (newValueKindForForm) {
        this.dataInternalMatchmaking = {
          kind: newValueKindForForm,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          note: "",
          type: constants.TYPE_FORM.IN_HOUSE_MATCH,
          is_online: this.isOnlineShop ? true : false,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 0
          }
        }
        if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
          if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
            this.itemFamilyNameMales = [this.customer.family_name + this.customer.given_name]
            this.phoneMale = this.customer.phone_number
            this.nameMale = this.customer.family_name + this.customer.given_name
            this.customerMaleFromHistory = true
          } else {
            this.itemFamilyNameFemales = [this.customer.family_name + this.customer.given_name]
            this.phoneFemale = this.customer.phone_number
            this.nameFemale = this.customer.family_name + this.customer.given_name
            this.customerFeMaleFromHistory = true
          }
        }
        this.typeSubmit = ''
        this.changeKind()
        this.getTimeAddFromKind()
        if (this.isValueForm.includes(newValueKindForForm)) {
          if(this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        }
      }
    },
    date: function (newDate) {
      if (newDate) {
        this.dataInternalMatchmaking.target_date = newDate
      }
    },
  },

  methods: {
    blurNameMale() {
      this.itemFamilyNameMales = [this.nameMaleOld]
      this.nameMale = this.nameMaleOld
      this.isFamilyName = false;
    },
    blurNameFemale() {
      this.itemFamilyNameFemales = [this.nameFemaleOld]
      this.nameFemale = this.nameFemaleOld
      this.isFamilyName = false;
    },

    // debounce
    async debounceMale(e, timeout = 300) {
      clearTimeout(this.timer);
      const gender = 1
      this.timer = setTimeout(() => { this.searchInputCustomerName(e, gender) }, timeout);
    },
    async debounceFemale(e, timeout = 300) {
      clearTimeout(this.timer);
      const gender = 2
      this.timer = setTimeout(() => { this.searchInputCustomerName(e, gender) }, timeout);
    },

    // forcus
    focusCustomerName() {
      this.isFamilyName = true;
    },

    // search input customer name
    async searchInputCustomerName(e, gender) {
      if (!this.isFamilyName || e == null || e == '') {
        return
      }

      const url = '/api/v1/customer/by-name/' + e + '?gender=' + gender
      const response = await this.$axios.get(url)
      if (gender == 1) {
        this.customerMales = response.data.customers
        this.itemFamilyNameMales = this.customerMales.map(item => {
          return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
        })
      } else {
        this.customerFemales = response.data.customers
        this.itemFamilyNameFemales = this.customerFemales.map(item => {
          return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
        })
      }
    },

    // input customer
    async inputCustomerNameMale(e) {
      if (e == null) {
        return
      }

      const customers = await this.customerMales.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNameMales = await [customers.family_name + customers.given_name]
        this.nameMale = await customers.family_name + customers.given_name
        this.nameMaleOld = await customers.family_name + customers.given_name
        this.phoneMale = await customers.phone_number;
        this.phoneMaleOld = await customers.phone_number
        this.dataInternalMatchmaking.male_customer_id = await customers.id
        this.maleCustomer = customers

        if (store.state.user.shop_id !== 0) {
          this.resetWhenChangeLayout()
          this.checkKindByCustomerShop()
        } else {
          this.resetWhenChangeLayoutForAdmin()
          this.checkKindByCustomerShopForAdmin()
        }

        this.genderOflastEnteredCustomer = CUSTOMER.GENDER.VAL.MALE
        if (this.maleCustomer && this.femaleCustomer) {
          this.checkMatchedHistoriesBefore(this.maleCustomer.id, this.femaleCustomer.id)
        }
      }

      this.isFamilyName = false;
    },
    async inputCustomerNameFemale(e) {
      if (e == null) {
        return
      }

      const customers = await this.customerFemales.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNameFemales = await [customers.family_name + customers.given_name]
        this.nameFemale = await customers.family_name + customers.given_name
        this.nameFemaleOld = await customers.family_name + customers.given_name
        this.phoneFemale = await customers.phone_number;
        this.phoneFemaleOld = await customers.phone_number
        this.dataInternalMatchmaking.female_customer_id = await customers.id
        this.femaleCustomer = customers

        if (store.state.user.shop_id !== 0) {
          this.resetWhenChangeLayout()
          this.checkKindByCustomerShop()
        } else {
          this.resetWhenChangeLayoutForAdmin()
          this.checkKindByCustomerShopForAdmin()
        }

        this.genderOflastEnteredCustomer = CUSTOMER.GENDER.VAL.FEMALE
        if (this.maleCustomer && this.femaleCustomer) {
          this.checkMatchedHistoriesBefore(this.maleCustomer.id, this.femaleCustomer.id)
        }
      }

      this.isFamilyName = false;
    },
    openDialogCV() {
      if (this.dataInternalMatchmaking.option.shift == 1) {
        this.dialogCV = true
      }
    },
    closeDialogCV() {
      this.dialogCV = false
      this.dataInternalMatchmaking.option.shift = 0
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    formatDateSlash(date) {
      if (!date) return null

      const [year, month, day] = date.split('/')
      return `${year}-${month}-${day}`
    },
    getMonth() {
      return moment(this.value).format("MM")
    },
    validateForm() {
      const validate = this.$refs.form.validate()

      return validate
    },
    validatePhone(e) {
      let validate = false;
      if (e.target.name == 'male') {
        validate = this.$refs.phoneMale.validate()
      } else {
        validate = this.$refs.phoneFemale.validate()
      }

      return validate;
    },

    checkHistory() {
      const validate = this.validateForm()
      if (validate == false) {
        return
      }
      let dataHistory = this.dataInternalMatchmaking
      if (this.historyData?.id) {
        dataHistory.id = this.historyData.id
      }
      this.$axios
        .post("/api/v1/customer/check-history", { dataHistory: dataHistory })
        .then((response) => {
          if (!response.data.canCreate) {
            let  errorMsg = '以下の予定と重複していますが、登録してよろしいですか？';
            if (response.data.conflictingAppointmentRes) {
              const { kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = response.data.conflictingAppointmentRes;
              errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
              errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
              errorMsg += `<p>${customerName}</p>`;
              errorMsg += `<p>担当：${counselorName}</p>`;
              errorMsg += `<p>ブース：${boothNoName || '--'}</p>`;
            }

            Swal.fire({
              html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
              confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
              confirmButtonColor: "#1e88e5",
              color: '#ffffff',
              showCancelButton: true,
              cancelButtonText: `<span style="font-size: 14px;">Cancel</span>`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.submit()
              }
            });
          } else {
            this.submit()
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    submit() {
      const validate = this.validateForm()
      if (validate == false) {
        return
      }

      if (this.customerMaleFromHistory) {
        this.dataInternalMatchmaking.male_customer_id = this.customer.id
      }

      if (this.customerFeMaleFromHistory) {
        this.dataInternalMatchmaking.female_customer_id = this.customer.id
      }
      if (!this.dataInternalMatchmaking.female_customer_id) {
        this.dataInternalMatchmaking.female_customer_id = constants.NOT_MEMBER_CUSTOMER
      }

      if (!this.dataInternalMatchmaking.male_customer_id) {
        this.dataInternalMatchmaking.male_customer_id = constants.NOT_MEMBER_CUSTOMER
      }

      if (this.dataInternalMatchmaking.status != this.statusPlan && this.dataInternalMatchmaking.status != this.statusImplementation) {
        this.dataInternalMatchmaking.option.result = null
        this.dataInternalMatchmaking.option.verTel = false
        this.dataInternalMatchmaking.option.follTel = false
        this.dataInternalMatchmaking.option.resTel = false
      }

      if (this.dataInternalMatchmaking.status != this.statusPlan) {
        this.dataInternalMatchmaking.option.verTel = false
      }

      if (this.dataInternalMatchmaking.status != this.statusImplementation) {
        this.dataInternalMatchmaking.option.result = null
        this.dataInternalMatchmaking.option.follTel = false
        this.dataInternalMatchmaking.option.resTel = false
      }

      if (this.dataInternalMatchmaking.status == this.statusImplementation && this.dataInternalMatchmaking.option.result != null && !this.dataInternalMatchmaking.option.isPay) {
        this.dataInternalMatchmaking.option.payVal = 0
      }

      const dataInternalMatchmaking = this.dataInternalMatchmaking;
      if (this.typeSubmit == 'update') {
        this.$axios
          .put(`/api/v1/customer/${this.dataInternalMatchmaking.customer_id}/history/${this.typeFormInHouseMatchmaking}`, { historyId: this.historyData.id, historyData: dataInternalMatchmaking })
          .then((response) => {
            this.dialogForm = false
            this.$emit('refreshListHistory')
            this.$emit('closeFormInHouseMatching')
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      } else {
        this.$axios
          .post("/api/v1/customer/internal-matchmaking", { dataInternalMatchmaking })
          .then((response) => {
            this.dialogForm = false
            this.resetForm()
            this.$emit('refreshCalendar')
            if (this.valueKindForForm) {
              this.$emit('refreshListHistory')
              this.$emit('closeFormInHouseMatching')
            }
            if (this.isLedgerScreen) {
              this.$emit('refreshLedgerData')
            }
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }

    },
    apiPhone(e) {
      this.isFamilyName = false;

      const validate = this.validatePhone(e)
      if (validate == false) {
        if (e.target.name == 'male') {
          this.phoneMaleOld = e.target.value
          this.nameMale = ''
          this.nameMaleOld = ''
          this.itemFamilyNameMales = []
          this.maleCustomer = null
          this.isTheSameShop = true
          this.dataInternalMatchmaking.counselor_id = ""
          this.dataInternalMatchmaking.booth_no_id = ""
        } else {
          this.dataInternalMatchmaking.counselor2_id = ""
          this.dataInternalMatchmaking.booth_no2_id = ""
          this.phoneFemaleOld = e.target.value
          this.nameFemale = ''
          this.nameFemaleOld = ''
          this.itemFamilyNameFemales = []
          this.femaleCustomer = null
        }

        return
      }

      let gender = e.target.name == 'male' ? 1 : 2
      if (this.phoneMale == this.phoneFemale) {
        alert('会員番号が重複しています。再度入力してください。')
        if (e.target.name == 'male') {
          this.phoneMale = ''
          this.maleCustomer = null
        } else {
          this.phoneFemale = ''
          this.femaleCustomer = null
        }

        return false;
      }
      this.$axios
        .get("/api/v1/customer/phone_number/" + e.target.value + '?gender=' + gender)
        .then((response) => {
          const customer = response.data.customer
          if (customer.id != undefined) {
            let isFemale = false
            if (e.target.name == 'male') {
              this.dataInternalMatchmaking.male_customer_id = customer.id
              this.nameMale = customer.family_name + customer.given_name;
              this.nameMaleOld = this.nameMale;
              this.itemFamilyNameMales = [this.nameMale]
              this.maleCustomer = customer
              this.genderOflastEnteredCustomer = CUSTOMER.GENDER.VAL.MALE
            } else {
              isFemale = true
              this.dataInternalMatchmaking.female_customer_id = customer.id
              this.nameFemale = customer.family_name + customer.given_name
              this.nameFemaleOld = this.nameFemale;
              this.itemFamilyNameFemales = [this.nameFemale]
              this.femaleCustomer = customer
              this.genderOflastEnteredCustomer = CUSTOMER.GENDER.VAL.FEMALE
            }
            if (store.state.user.shop_id !== 0) {
              this.resetWhenChangeLayout(isFemale)
              this.checkKindByCustomerShop()
            } else {
              this.resetWhenChangeLayoutForAdmin(isFemale)
              this.checkKindByCustomerShopForAdmin()
            }
            if (this.maleCustomer && this.femaleCustomer) {
              this.checkMatchedHistoriesBefore(this.maleCustomer.id, this.femaleCustomer.id)
            }
          } else {
            alert('対象者が存在しません')
            if (e.target.name == 'male') {
              this.phoneMale = ''
              this.nameMale = ''
              this.itemFamilyNameMales = []
              this.maleCustomer = null
            } else {
              this.phoneFemale = ''
              this.nameFemale = ''
              this.itemFamilyNameFemales = []
              this.femaleCustomer = null
            }
            return false;
          }

        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    onDialog() {
      this.$emit('closeMenu')
      this.dialogForm = true
    },
    closeDialog() {
      this.dialogForm = false
      this.resetForm()
      this.$emit('closeFormInHouseMatching')
    },
    getTimeAddFromKind() {
      this.$axios
        .get("/api/v1/date-setting/" + CUSTOMER.EXEC_KIND.VAL.MATCHING)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    resetForm() {
      if(this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      if (this.typeSubmit == 'update' && this.dataInternalMatchmaking.option.shift == 1) {
        this.dataInternalMatchmaking = {
          kind: CUSTOMER.EXEC_KIND.NAME.MATCHING,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          counselor2_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          booth_no2_id: "",
          note: "",
          type: constants.TYPE_FORM.IN_HOUSE_MATCH,
          is_online: this.isOnlineShop ? true : false,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 1
          }
        }
        this.phoneMale = ''
        this.nameMale = ''
        this.phoneFemale = ''
        this.nameFemale = ''
        this.maleCustomer = null
        this.femaleCustomer = null
        this.isTheSameShop = true
      } else if (this.typeSubmit == 'update') {
        if (this.historyData.type == constants.TYPE_FORM.IN_HOUSE_MATCH && this.valueKindForForm.length == 0) {
          this.dataInternalMatchmaking.kind = this.historyData.kind
          this.dataInternalMatchmaking.target_date = this.formatDateSlash(this.historyData.target_date)
          this.dataInternalMatchmaking.target_time = this.historyData.target_time
          this.dataInternalMatchmaking.target_time_end = this.historyData.target_time_end
          this.dataInternalMatchmaking.customer_id = this.historyData.customer_id
          this.dataInternalMatchmaking.booth_no_id = this.historyData.booth_no_id
          this.dataInternalMatchmaking.booth_no2_id = this.historyData.booth_no2_id
          this.dataInternalMatchmaking.counselor_id = this.historyData.counselor_id
          this.dataInternalMatchmaking.counselor2_id = this.historyData.counselor2_id
          this.dataInternalMatchmaking.note = this.historyData.note
          this.phoneMale = this.historyData.male_customer.phone_number
          this.nameMale = this.historyData.male_customer.family_name + this.historyData.male_customer.given_name
          this.itemFamilyNameMales = [this.nameMale]
          this.dataInternalMatchmaking.option.counterpart_history_id = this.historyData.option.counterpart_history_id
          this.dataInternalMatchmaking.option.female_customer_id = this.historyData.option.female_customer_id
          this.dataInternalMatchmaking.option.isPay = this.historyData.option.isPay
          this.dataInternalMatchmaking.option.male_customer_id = this.historyData.option.male_customer_id
          this.dataInternalMatchmaking.option.match_reserve_id = this.historyData.option.match_reserve_id
          this.dataInternalMatchmaking.option.result = this.historyData.option.result
          this.dataInternalMatchmaking.option.shift = this.historyData.option.shift
          this.dataInternalMatchmaking.option.verTel = this.historyData.option.verTel
          this.dataInternalMatchmaking.option.follTel = this.historyData.option.follTel
          this.dataInternalMatchmaking.option.resTel = this.historyData.option.resTel
          this.dataInternalMatchmaking.option.payVal = this.historyData.option.payVal
          this.dataInternalMatchmaking.status = this.historyData.status
          this.phoneFemale = this.historyData.female_customer.phone_number
          this.nameFemale = this.historyData.female_customer.family_name + this.historyData.female_customer.given_name
          this.itemFamilyNameFemales = [this.nameFemale]
          this.dataInternalMatchmaking.male_customer_id = this.historyData.male_customer.id
          this.dataInternalMatchmaking.female_customer_id = this.historyData.female_customer.id
        }
      } else {
        this.dataInternalMatchmaking = {
          kind: '',
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          counselor2_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          booth_no2_id: "",
          note: "",
          type: constants.TYPE_FORM.IN_HOUSE_MATCH,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 0
          }
        }
        this.phoneMale = ''
        this.nameMale = ''
        this.phoneFemale = ''
        this.nameFemale = ''

        if (this.customerMaleFromHistory) {
          this.itemFamilyNameMales = [this.customer.family_name + this.customer.given_name]
          this.phoneMale = this.customer.phone_number
          this.nameMale = this.customer.family_name + this.customer.given_name
          this.phoneFemale = ''
          this.nameFemale = ''
        }

        if (this.customerFeMaleFromHistory) {
          this.itemFamilyNameFemales = [this.customer.family_name + this.customer.given_name]
          this.phoneFemale = this.customer.phone_number
          this.nameFemale = this.customer.family_name + this.customer.given_name
          this.phoneMale = ''
          this.nameMale = ''
        }
        this.maleCustomer = null
        this.femaleCustomer = null
        this.isTheSameShop = true
      }

      if (this.valueKindForForm) {
        this.dataInternalMatchmaking.kind = this.valueKindForForm
      }
    },
    changeTimeStart(newStartAt) {
      if (newStartAt != "") {
        const startAt = moment(newStartAt, 'HH:mm')
        this.dataInternalMatchmaking.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
        this.minTime = moment(this.dataInternalMatchmaking.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
      }
    },
    saveTimeStart() {
      this.changeTimeStart(this.dataInternalMatchmaking.target_time)
      this.$refs.dialog1.save(this.dataInternalMatchmaking.target_time)
    },
    changeKind() {
      if (this.dataInternalMatchmaking.kind === CUSTOMER.EXEC_KIND.VAL.SOLO_INTRODUCTION) {
        this.$emit('switchForm', CUSTOMER.TYPE_FORM.INPUT_PARTNER_SELECTION, CUSTOMER.EXEC_KIND.VAL.SOLO_INTRODUCTION)
        return
      }
      this.$axios
        .get("/api/v1/date-setting/" + this.dataInternalMatchmaking.kind)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
          if (this.dataInternalMatchmaking.target_time != "") {
            const startAt = moment(this.dataInternalMatchmaking.target_time, 'HH:mm')
            this.dataInternalMatchmaking.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    async fetchBoothNos(counselorsArray, counselorIdKey, validBoothNosKey, boothNoIdKey) {
      const counselorSelected = counselorsArray.find(counselor => counselor.id === this.dataInternalMatchmaking[counselorIdKey]);
      await this.$axios.get(`/api/v1/booth_no/shop/${counselorSelected.shop_id}`)
        .then((response) => {
          this[validBoothNosKey] = response.data.booth_nos;
          if (response.data.booth_nos.length > 0 && response.data?.booth_nos[0]?.shop_id != counselorSelected.shop_id) {
            this.dataInternalMatchmaking[boothNoIdKey] = "";
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    async onCounselorSelected() {
      await this.fetchBoothNos(this.counselors1, 'counselor_id', 'validBoothNos', 'booth_no_id');
    },
    async onCounselor1Selected() {
      await this.fetchBoothNos(this.counselors1, 'counselor_id', 'validBoothNos', 'booth_no_id');
    },
    async onCounselor2Selected() {
      await this.fetchBoothNos(this.counselors2, 'counselor2_id', 'validBoothNos2', 'booth_no2_id');
    },
    getCO(customer) {
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${customer.shop_id}`)
        .then((response) => {
          if (customer.gender === CUSTOMER.GENDER.VAL.MALE) {
            this.counselors1 = response.data.counselors
          } else {
            this.counselors2 = response.data.counselors
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    getCounselors() {
      const currentShopId = store.state.user.shop_id
      if (this.maleCustomer !== null) {
        if (this.maleCustomer.shop_id !== currentShopId) {
          this.getCO(this.maleCustomer)
          this.isTheSameShop = false
        } else {
          this.counselors1 = this.counselors
        }
      }
      if (this.femaleCustomer !== null) {
        if (this.femaleCustomer.shop_id !== currentShopId) {
          this.getCO(this.femaleCustomer)
          this.isTheSameShop = false
        } else {
          this.counselors2 = this.counselors
        }
      }

      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        if (this.maleCustomer === currentShopId && this.femaleCustomer === currentShopId) {
          this.counselors1 = this.counselors
          this.isTheSameShop = true
        } else if (this.maleCustomer !== currentShopId && this.femaleCustomer !== currentShopId) {
          this.counselors1 = this.counselors
          this.isTheSameShop = this.maleCustomer.shop_id === this.femaleCustomer.shop_id
        }
      }
    },
    getCounselorsForAdmin() {
      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        if (this.maleCustomer.shop_id === this.femaleCustomer.shop_id) {
          this.counselors1 = this.counselors
          this.isTheSameShop = true
        } else {
          this.getCO(this.maleCustomer)
          this.getCO(this.femaleCustomer)
          this.isTheSameShop = false
        }
      }
    },
    checkKindByCustomerShop() {
      const currentShopId = store.state.user.shop_id
      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        if (currentShopId === 0) {
          this.dataInternalMatchmaking.kind = this.maleCustomer.shop_id !== this.femaleCustomer.shop_id
            ? CUSTOMER.EXEC_KIND.VAL.OTHER_BRANCH_MATCHMAKING
            : CUSTOMER.EXEC_KIND.VAL.MATCHING;
        }
      }
    },
    resetWhenChangeLayout(isFemale = false) {
      const isTheSameShopBefore = this.isTheSameShop
      const currentShopId = store.state.user.shop_id
      if (this.maleCustomer !== null) {
        if (this.maleCustomer.shop_id !== currentShopId) {
          this.getCO(this.maleCustomer)
          this.isTheSameShop = false
        }
      }
      if (this.femaleCustomer !== null) {
        if (this.femaleCustomer.shop_id !== currentShopId) {
          this.getCO(this.femaleCustomer)
          this.isTheSameShop = false
        } else {
          this.counselors2 = this.counselors
        }
      }

      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        if (this.maleCustomer === currentShopId && this.femaleCustomer === currentShopId) {
          this.counselors1 = this.counselors
          this.isTheSameShop = true
        } else if (this.maleCustomer !== currentShopId && this.femaleCustomer !== currentShopId) {
          this.counselors1 = this.counselors
          this.isTheSameShop = this.maleCustomer.shop_id === this.femaleCustomer.shop_id
        }
      }

      if (isTheSameShopBefore !== this.isTheSameShop) {
        if (!isFemale) {
          this.dataInternalMatchmaking.counselor_id = ""
          this.dataInternalMatchmaking.booth_no_id = ""
          this.validBoothNos = []
        } else {
          this.dataInternalMatchmaking.counselor2_id = ""
          this.dataInternalMatchmaking.booth_no2_id = ""
          this.validBoothNos2 = []
        }
      }
    },
    getListCounselorInitial() {
      this.counselors1 = this.counselors
    },
    resetWhenChangeLayoutForAdmin(isFemale = false) {
      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        const isTheSameShopBefore = this.isTheSameShop

        if (this.maleCustomer.shop_id === this.femaleCustomer.shop_id) {
          this.counselors1 = this.counselors
          this.isTheSameShop = true
          this.getCO(this.maleCustomer)
        } else {
          this.getCO(this.maleCustomer)
          this.getCO(this.femaleCustomer)
          this.isTheSameShop = false
        }

        if (isTheSameShopBefore !== this.isTheSameShop) {
          if(!isFemale) {
            this.dataInternalMatchmaking.counselor_id = ""
            this.dataInternalMatchmaking.booth_no_id = ""
            this.validBoothNos = []
          } else {
            this.dataInternalMatchmaking.counselor2_id = ""
            this.dataInternalMatchmaking.booth_no2_id = ""
            this.validBoothNos2 = []
          }
        }
      }
    },
    checkKindByCustomerShopForAdmin() {
      if (this.maleCustomer !== null && this.femaleCustomer !== null) {
        this.dataInternalMatchmaking.kind = this.maleCustomer.shop_id !== this.femaleCustomer.shop_id
          ? CUSTOMER.EXEC_KIND.VAL.OTHER_BRANCH_MATCHMAKING
          : CUSTOMER.EXEC_KIND.VAL.MATCHING;
      }
    },
    checkMatchedHistoriesBefore(male_customer_id, female_customer_id) {
      let apiUrl = `/api/v1/customer/history/check-matched-histories?male_customer_id=${male_customer_id}&female_customer_id=${female_customer_id}`
      if (this.customer) {
        apiUrl += `&main_customer_gender=${this.customer.gender}`
      }
      this.$axios
        .get(apiUrl)
        .then((response) => {
          let matchedHistoriesNum = 0
          if (response.data.isMatchedHistoriesBefore) {
            response.data.matchedHistories.map(history => {
              if (this.typeSubmit !== 'update' || (this.typeSubmit === 'update' && history.id != this.historyData.id)) {
                matchedHistoriesNum++
              }
            })
          }
          if (matchedHistoriesNum > 0) {
            this.showConfirmCustomerSame = true
          }
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    closePopupChangeMatchedCustomer() {
      this.showConfirmCustomerSame = false
    },
    changeMatchedCustomer() {
      if (this.genderOflastEnteredCustomer === CUSTOMER.GENDER.VAL.MALE) {
        this.phoneMale = ''
        this.nameMale = ''
        this.itemFamilyNameMales = []
        this.maleCustomer = null
        this.dataInternalMatchmaking.counselor_id = ''
        this.dataInternalMatchmaking.booth_no_id = ''
        this.validBoothNos = []
      } else {
        this.phoneFemale = ''
        this.nameFemale = ''
        this.itemFamilyNameFemales = []
        this.femaleCustomer = null
        this.dataInternalMatchmaking.counselor2_id = ''
        this.dataInternalMatchmaking.booth_no2_id = ''
        this.validBoothNos2 = []
      }
      this.showConfirmCustomerSame = false
    },
    openMemoModal() {
      if (this.memoDialog) return;
      this.memoDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
      });
    },
    checkMemoContentAndOpenModal(content, maxLines = 3) {
      if (!content || !content.trim()) return;
      
      const explicitLineCount = content.split(/\r?\n/).length;
      
      if (explicitLineCount > maxLines) {
        this.openMemoModal();
        return;
      }
      
      this.$nextTick(() => {
        const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
          ? this.$refs.memoTextarea.$el.querySelector('textarea')
          : null;
        
        if (textarea) {
          const originalHeight = textarea.style.height;
          textarea.style.height = 'auto';
          
          const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
          const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
          
          textarea.style.height = originalHeight;
          
          if (visualLines > maxLines) {
            this.openMemoModal();
          }
        }
      });
    },
    onMemoInput(val) {
      const content = typeof val === 'string' ? val : (this.dataInternalMatchmaking.note || '');
      this.checkMemoContentAndOpenModal(content, 3);
    },
    onMemoClick() {
      const content = this.dataInternalMatchmaking.note || '';
      this.checkMemoContentAndOpenModal(content, 3);
    },
  }
}
</script>

<style scoped>
.body-content-dialog {
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.container.grid-list-md .layout .flex {
  padding: 4px 12px;
}

/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>
